import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { Box } from '@mui/material';
import { estilos } from '../config/estilos';

const TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'span', 'a', 'ul', 'ol', 'li', 'h3', 'blockquote'];
const ATRIBUTOS = ['style', 'href', 'target', 'rel'];

DOMPurify.addHook('afterSanitizeAttributes', (no) => {
    if (no.tagName === 'A') {
        no.setAttribute('target', '_blank');
        no.setAttribute('rel', 'noopener noreferrer');
    }
});

function pareceHtml(texto) {
    return /<\/?[a-z][\s\S]*>/i.test(texto);
}

export function ConteudoFormatado({ html, vazio = '', sx }) {
    const seguro = useMemo(() => {
        if (!html) return '';

        const fonte = pareceHtml(html)
            ? html
            : html
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\n/g, '<br>');

        return DOMPurify.sanitize(fonte, { ALLOWED_TAGS: TAGS, ALLOWED_ATTR: ATRIBUTOS });
    }, [html]);

    if (!seguro) {
        return vazio ? <Box sx={{ ...estilos, color: 'text.disabled', ...sx }}>{vazio}</Box> : null;
    }

    return <Box sx={{ ...estilos, ...sx }} dangerouslySetInnerHTML={{ __html: seguro }} />;
}